import {createTheme} from '@mui/material/styles';

export const theme = createTheme({
    '@global': {
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            outline: '1px solid slategrey'
        }
    },
    typography: {
        fontFamily: 'IRANSans, Arial',
    },
    palette: {
        action: {
            disabledBackground: '#B9C1C7',
            disabled: '#eeeeee'
        },
        primary: {
            main: '#FD6A16',
            contrastText: '#FFF'
        },
        secondary: {
            main: 'rgba(253,106,22,0.12)',
            contrastText: '#FD6A16'
        },
        error: {
            main: "#FF4545"
        },
        orange: {
            main: "#FF9737"
        },
        yellow: {
            main: "#FFD058"
        },
        success: {
            main: "#63C174"
        },
        info: {
            main: '#2981EC',
            light: 'rgba(29, 116, 221, 0.12)'
        },
        fourth: {
            main: '#B9C1C7'
        },
        tertiary: {
            main: '#242424'
        },
        background: {
            default: "#FFF",
            second: 'rgba(253,106,22,0.12)',
            redLight: 'rgba(255, 69, 69, 0.12)',
        },
        text: {
            primary: "#D9E2E7",
            secondary: "#FD6A16",
            main: '#7A7A7A',
        },
    },
});

